import React from 'react';

import DataModelView from '../../common/view/DataModelView';

import './ContractLimitsView.css';

export default class ContractLimitsView extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'currentContracts'
    ];
  }

  render() {
    var contracts = this.state.currentContracts.filter(
      contract => contract.enableViewValues && contract.showContractLimits
    );

    if (contracts.length === 0)
      return (<div />);

    return (
      <div className="pwx-contract-limits-sidebar">
        {contracts.map(contract => (
          <div key={contract.code} >
            <div className="pwx-contract-limits-header">{contract.displayName}</div>
            <div className="pwx-contract-limits-content">
              <span className="pwx-contract-limits-field-name">Min: </span>
              <span className="pwx-contract-limits-field-value">{contract.hourlyEnergyMinimum} MWh</span>
              <span className="pwx-contract-limits-field-name">, Max: </span>
              <span className="pwx-contract-limits-field-value">{contract.hourlyEnergyMaximum} MWh</span><br />
              <span className="pwx-contract-limits-field-name">Cutoff: </span>
              <span className="pwx-contract-limits-field-value">{contract.cutOffDetails}</span>
            </div>
          </div>
          )
        )}

      </div>
    );
  }
}
